// src/app/services/tour.service.ts
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  DynamicCombiPrepareRequest,
  DynamicCombiPrepareResponse,
  TourEligibleServiceDao,
} from '../db-models/tour-dao';

@Injectable({ providedIn: 'root' })
export class TourService {
  private http = inject(HttpClient);

  /**
   * Load tour-eligible services for a store with their travel-time matrix
   * attached. Uses the extended appointment_services_by_store endpoint.
   */
  loadTourServices(storeId: number): Observable<TourEligibleServiceDao[]> {
    const body = {
      store_id: storeId,
      is_tour_eligible: true,
      strict_travel_time_mapped: true,
      include_travel_times: true,
    };
    return this.http.post<TourEligibleServiceDao[]>(
      `${environment.apiUrl}appointment_services/appointment_services_by_store`,
      body
    );
  }

  /**
   * Create (or find) a dynamic combi service for the given ordered list of
   * component service UUIDs. Returns the combi_service_id used by the
   * downstream free_appointments + book calls.
   */
  prepareDynamicCombi(
    payload: DynamicCombiPrepareRequest
  ): Observable<DynamicCombiPrepareResponse> {
    return this.http.post<DynamicCombiPrepareResponse>(
      `${environment.apiUrl}dynamic-combis/prepare`,
      payload
    );
  }
}
